<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">成人教育选课</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <div style="display:inline-block;">
                            <el-button @click="personalInfo" type="success" style="margin-left: 10px">
                                <i class="el-icon-document-copy"></i>&nbsp;个人报名信息
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <el-table :data="tableData" v-loading.body="tableLoading" @row-click="rowClick"
                      element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable" stripe fit >
                <el-table-column label="序号" width="50" fixed align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="学年学期" prop="xnxqmc" align="center"></el-table-column>
                <el-table-column label="选修班名称" prop="electiveClassName" align="center" ></el-table-column>
                <el-table-column label="教师姓名" prop="teacherName" align="center" ></el-table-column>
                <el-table-column label="场地名称" prop="siteName" align="center" ></el-table-column>
                <el-table-column label="授课周次" prop="teachingWeek" align="center" ></el-table-column>
                <el-table-column label="上课时间" prop="totalClassHours" align="center" :formatter="timeSeriesFormatter"></el-table-column>
                <el-table-column label="报名人数" prop="studentNumber" align="center"></el-table-column>
                <el-table-column label="总人数" prop="quotaNumber" align="center"></el-table-column>
                <el-table-column label="备注" prop="remarks" align="center"></el-table-column>
                <el-table-column label="操作" align="center" min-width="10%">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.selectCourse!='1'" size="small" @click="selectCourse(scope.row);" type="primary">
                            <i class="el-icon-tickets"></i>&nbsp;选课
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                               :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>

            <!-- 个人选课信息 -->
            <el-dialog :title="'个人选课信息'" class="personalInfoDialog" width="80%" top="13vh" :visible.sync="personalInfoDialogVisible" @closed="closePersonalInfoDialog" append-to-body>
                <el-table :data="personalInfoData" v-loading.body="tableLoading" element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="personalInfoTableHeight" ref="personalInfoTable">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{ (currentPage_personalInfo - 1) * limit_personalInfo + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="学年学期" prop="xnxqmc" align="center" ></el-table-column>
                    <el-table-column label="学号" prop="studentCode" align="center" ></el-table-column>
                    <el-table-column label="姓名" prop="studentName" align="center" ></el-table-column>
                    <el-table-column label="选修班名称" prop="electiveClassName" align="center" ></el-table-column>
                    <el-table-column label="选修课类型" prop="courseTypeName" align="center" ></el-table-column>
                    <el-table-column label="学分" prop="credit" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" width="90px">
                        <template slot-scope="scope">
                            <el-button size="small" v-if="currentXnxq==scope.row.xnxqbm" @click="delSelection(scope.row);" type="danger">
                                <i class="el-icon-tickets"></i>&nbsp;删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="width:100%;height:20px;">
                </div>
            </el-dialog>

            <!-- 错误信息 -->
            <el-dialog :title="'错误信息'" width="400px" :top="topHeight" :visible.sync="errorDialogVisible" @closed="closeErrorDialog" append-to-body>
                <div class="errorDiv" v-html="errorMessage"></div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {confirmMsg} from "utils/message";

export default {
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                xnxqbm: null,
                electiveDetailCode: null,
                courseType: "",
                courseName: null,
                state: null,
                isDivideTab: "1",//是体育选修课
            },
            personForm: {
                pageNum: 1,
                rowNum: 10,
                xnxqbm: null,
                electiveDetailCode: null,
                courseType: "",
                courseName: null,
                state: null,
                isDivideTab: "1",//是体育选修课
            },
            xnxqInfo: [], //学年学期下拉框
            courseTypeInfo: [], //课程类型下拉框
            courseInfo: [], //课程下拉框
            classWeekInfo: [], //上课日期下拉框
            classTimeInfo: [], //上课时间下拉框
            examinationFormInfo: [], //考试形式下拉框
            registrableDeptInfo: [], //可报名系部下拉框
            registrableMajorInfo: [], //可报名专业下拉框
            registrableClassInfo: [], //可报名班级下拉框
            registrableGradeInfo: [], //可报名年级下拉框
            registrableRecruitNatureInfo: [], //可报名层次类型下拉框
            isDivideInfo: [],//是否分班教学选修课下拉框
            stateInfo: [],//状态下拉框
            majorInfo: [],//专业下拉框
            gradeInfo: [],//年级下拉框
            tableData: [],
            currentXnxq: null,//当前学期
            checkSelection: false,//是否在选课时间范围内
            currentPage: 1,
            limit: 10,
            total: null,
            tableLoading: true,
            selectRowData: null,
            mainTableHeight: 500,
            dialogTitle: "",
            dialogVisible: false,
            formSubmiting: false,
            editType: null,
            stuInfo: null,

            limit_personalInfo: 10,
            currentPage_personalInfo: 1,
            personalInfoData: [],
            personalInfoTableHeight: 500,
            personalInfoDialogVisible: false,
            topHeight: 0 + 'px',
            errorDialogVisible: false,
            errorMessage: '',
            weekall: null,
        };
    },
    created() {
        this.initParam();
    },
    mounted() {
        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            this.topHeight = (window.innerHeight - 274 - 200) / 2 + 'px';

            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            };
        });
    },
    methods: {
        showHomePage() {
            this.$router.push('/m/wx/home');
        },
        initParam() {
            this.initOption();

            //判断是否在选课时间范围内
            const paramMap = {
                'courseType': 'ty'
            }
            this.$api.electiveManageAdultEducation.studentSelection.checkSelectTime({
                data: paramMap
            }).then(response => {
                this.currentXnxq = response.data.data.xnxqbm;
                this.checkSelection = response.data.data.result;
                if (this.checkSelection == "true") {
                    this.queryList();
                } else {
                    this.$alert('当前时间未开放选课', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                    this.tableLoading = false;
                }

            }).catch(error => {
                console.log(error);
            });
        },
        initOption() {
            const paramMap = {
                'name': 'combo_Info'
            }
            this.$api.electiveManageAdultEducation.studentSelection.initOption({
                data: paramMap
            }).then(response => {
                this.courseTypeInfo = response.data.data.courseType;
            }).catch(error => {
                console.log(error);
            });
        },
        queryList() {
            if (this.checkSelection == "true") {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;
                this.queryForm.xnxqbm = this.currentXnxq;

                this.$api.electiveManageAdultEducation.studentSelection.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.weekall = response.data.data.weekall;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            }
        },
        rowClick(row) {
            this.selectRowData = row;
        },
        selectCourse(row) {
            confirmMsg('确定选择这门课程？').then(() => {
                const paramMap = {
                    'pageNum': this.currentPage,
                    'rowNum': this.limit,
                    'xnxqbm': this.currentXnxq,
                    'electiveDetailCode': row.electiveDetailCode,
                    'courseType': row.courseType,
                    'isDivideTab': '1',
                }
                this.$api.electiveManageAdultEducation.studentSelection.studentSelection({
                    data: paramMap
                }).then(response => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "保存成功",
                            type: "success",
                            duration: 1500,
                        });

                        this.currentPage = 1;
                        this.limit = 10;
                        this.queryList();
                        this.selectRowData = null;
                    } else {
                        this.$alert(msg, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                    }
                }).catch(error => {
                    console.log(error);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消选择'
                });
            });
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.limit = val;
            this.currentPage = 1;
            this.queryList();
        },
        closeErrorDialog() {
            this.errorMessage = '';
            this.errorDialogVisible = false;
        },
        personalInfo() {
            this.queryStuSelection();
            this.personalInfoDialogVisible = true;
        },
        //查询学生所有选课信息
        queryStuSelection() {
            this.tableLoading = true;
            this.personForm.pageNum = this.currentPage_personalInfo;
            this.personForm.rowNum = this.limit_personalInfo;
            this.personForm.xnxqbm = this.currentXnxq;

            this.$api.electiveManageAdultEducation.studentSelection.queryStuSelection({
                data: this.personForm,
            }).then((response) => {
                this.personalInfoData = response.data.data.list;
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        changeCourseType() {
            this.queryStuSelection();
        },
        delSelection(row) {
            const paramMap = {
                'xnxqbm': this.currentXnxq,
                'electiveDetailCode': row.electiveDetailCode,
                'studentCode': row.studentCode,
                'isDivideTab': '1',
            };
            confirmMsg('是否确认删除该选课信息？').then(() => {
                this.$api.electiveManageAdultEducation.studentSelection.delSelection({
                    data: paramMap
                }).then(response => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "删除成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.queryStuSelection();
                    } else {
                        this.$notify({
                            title: "失败",
                            message: msg ? msg : '删除失败',
                            type: "error",
                            duration: 3000,
                        });
                    }
                }).catch(error => {
                    this.formSubmiting = false;
                    this.$notify({
                        title: '错误',
                        message: error, /// l..
                        type: 'error',
                        duration: 3000,
                    });
                    console.log(error);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        closePersonalInfoDialog() {
            this.personalInfoDialogVisible = false;
        },
        more() {
            if (this.hideQueryArea == false) {
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 205;
                this.$nextTick(function () {
                    this.hideQueryArea = true;
                });
            } else {
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 85;
                this.$nextTick(function () {
                    this.hideQueryArea = false;
                });
            }
        },
        //失去焦点直接获取输入的单位名称
        unitblur(e, item, index) {
            if (e.target.value != '') {
                this.editForm.internshipUnitId = e.target.value;
            }
        },
        getCurrentFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        timeSeriesFormatter(row) {
            if (row.timeSeries == "" || row.timeSeries == undefined) {
                return "";
            }
            if (row.timeSeries.indexOf(";") > -1 || row.timeSeries.indexOf("{") > -1) {
                return row.timeSeries;
            } else {
                let result = "";

                let timeSeries = row.timeSeries.split(",");
                let skxq = timeSeries[0].substring(0, 2);
                let sksj = timeSeries[0].substring(0, 2) + timeSeries[0].substring(2, 4) + ",";
                if (timeSeries.length == 1) {
                    sksj = sksj.substring(0, sksj.length - 1);
                    result += this.dayFormatter(sksj, row) + "；";
                } else {
                    for (let j = 1; j < timeSeries.length; j++) {
                        if (timeSeries[j].substring(0, 2) == skxq) {
                            sksj += timeSeries[j].substring(0, 2) + timeSeries[j].substring(2, 4) + ",";
                            if (j == timeSeries.length - 1) {//最后一项
                                sksj = sksj.substring(0, sksj.length - 1);
                                result += this.dayFormatter(sksj, row) + "；";
                            }
                        } else {
                            //不相同
                            sksj = sksj.substring(0, sksj.length - 1);
                            result += this.dayFormatter(sksj, row) + "；";
                            //最后一项
                            skxq = timeSeries[j].substring(0, 2);
                            sksj = timeSeries[j].substring(0, 2) + timeSeries[j].substring(2, 4) + ",";
                            if (j == timeSeries.length - 1 && timeSeries[j - 1].substring(0, 2) != timeSeries[j].substring(0, 2)) {
                                sksj = sksj.substring(0, sksj.length - 1);
                                result += this.dayFormatter(sksj, row) + "；";
                            }
                        }
                    }
                }
                return result;
            }
        },
        dayFormatter(sksj, row) {
            let sw = parseInt(row.sw, 10);
            let zw = parseInt(row.zw, 10);
            let xw = parseInt(row.xw, 10);
            let ws = parseInt(row.ws, 10);

            var sksj2 = sksj.split(",");
            var week = sksj2[0].substring(0, 2);
            if (week == "01") {
                week = "周一";
            } else if (week == "02") {
                week = "周二";
            } else if (week == "03") {
                week = "周三";
            } else if (week == "04") {
                week = "周四";
            } else if (week == "05") {
                week = "周五";
            } else if (week == "06") {
                week = "周六";
            } else if (week == "07") {
                week = "周日";
            }

            var apm = "";
            var num = "";
            var lxsw = "-1";
            var lxzw = "-1";
            var lxxw = "-1";
            var lxws = "-1";
            var jcsw = -1;
            var jczw = -1;
            var jcxw = -1;
            var jcws = -1;
            var jczws = -1;
            var jcxws = -1;
            var jcwss = -1;
            //判断连续
            for (var i = 0; i < sksj2.length; i++) {
                var apm = parseInt(sksj2[i].substring(2, 4), 10);
                if (apm <= sw) {//上午
                    jcsw = i;
                    if (i > 0 && lxsw != "0") {
                        if (parseInt(sksj2[i].substring(2, 4), 10) - parseInt(sksj2[i - 1].substring(2, 4), 10) == 1) {
                            lxsw = "1";
                        } else {
                            lxsw = "0";
                        }
                    }
                }
            }
            if (jcsw != -1) {
                jczws = jcsw + 1;
            } else {
                jczws = 0;
            }
            for (var i = 0; i < sksj2.length; i++) {
                var apm = parseInt(sksj2[i].substring(2, 4), 10);
                if (apm > sw && apm <= (sw + zw)) {//中午
                    jczw = i;
                    if (i > 0 && lxzw != "0") {
                        if (parseInt(sksj2[i - 1].substring(2, 4), 10) > sw) {
                            if (parseInt(sksj2[i].substring(2, 4), 10) - parseInt(sksj2[i - 1].substring(2, 4), 10) == 1 && parseInt(sksj2[i - 1].substring(2, 4), 10) > sw) {
                                lxzw = "1";
                            } else {
                                lxzw = "0";
                            }
                        }
                    }
                }
            }
            if (jczw != -1) {
                jcxws = jczw + 1;
            } else {
                if (jcsw != -1) {
                    jcxws = jcsw + 1;
                } else {
                    jcxws = 0;
                }
            }
            for (var i = 0; i < sksj2.length; i++) {
                var apm = parseInt(sksj2[i].substring(2, 4), 10);
                if (apm > (sw + zw) && apm <= (sw + zw + xw)) {//下午
                    jcxw = i;
                    if (i > 0 && lxxw != "0") {
                        if (parseInt(sksj2[i - 1].substring(2, 4), 10) > (sw + zw)) {
                            if (parseInt(sksj2[i].substring(2, 4), 10) - parseInt(sksj2[i - 1].substring(2, 4), 10) == 1) {
                                lxxw = "1";
                            } else {
                                lxxw = "0";
                            }
                        }
                    }
                }
            }
            if (jcxw != -1) {
                jcwss = jcxw + 1;
            } else {
                if (jczw != -1) {
                    jcwss = jczw + 1;
                } else {
                    if (jcsw != -1) {
                        jcwss = jcsw + 1;
                    } else {
                        jcwss = 0;
                    }
                }
            }
            for (var i = 0; i < sksj2.length; i++) {
                var apm = parseInt(sksj2[i].substring(2, 4), 10);
                if (apm > (sw + zw + xw)) {//晚上
                    jcws = i;
                    if (i > 0 && lxws != "0") {
                        if (parseInt(sksj2[i - 1].substring(2, 4), 10) > (sw + zw + xw)) {
                            if (parseInt(sksj2[i].substring(2, 4), 10) - parseInt(sksj2[i - 1].substring(2, 4), 10) == 1) {
                                lxws = "1";
                            } else {
                                lxws = "0";
                            }
                        }
                    }
                }
            }

            if (lxsw == "1") {
                num += "上午第" + parseInt(sksj2[0].substring(2, 4), 10) + "-" + parseInt(sksj2[jcsw].substring(2, 4), 10) + ",";
            } else {
                for (var i = 0; i <= jcsw; i++) {
                    num += "上午第" + parseInt(sksj2[i].substring(2, 4), 10) + ",";
                }
            }
            if (lxzw == "1") {
                num += "中午第" + (parseInt(sksj2[jczws].substring(2, 4), 10) - sw) + "-" + (parseInt(sksj2[jczw].substring(2, 4), 10) - sw) + ",";
            } else {
                for (var i = jcsw + 1; i <= jczw; i++) {
                    num += "中午第" + (parseInt(sksj2[i].substring(2, 4), 10) - sw) + ",";
                }
            }
            if (lxxw == "1") {
                num += "下午第" + (parseInt(sksj2[jcxws].substring(2, 4), 10) - sw - zw) + "-" + (parseInt(sksj2[jcxw].substring(2, 4), 10) - sw - zw) + ",";
            } else {
                var st = -1;
                if (jczw == -1) {
                    st = jcsw;
                } else {
                    st = jczw;
                }
                for (var i = st + 1; i <= jcxw; i++) {
                    num += "下午第" + (parseInt(sksj2[i].substring(2, 4), 10) - sw - zw) + ",";
                }
            }
            if (lxws == "1") {
                num += "晚上第" + (parseInt(sksj2[jcwss].substring(2, 4), 10) - sw - zw - xw) + "-" + (parseInt(sksj2[jcws].substring(2, 4), 10) - sw - zw - xw) + ",";
            } else {
                var st = -1;
                if (jcxw == -1) {
                    if (jczw == -1) {
                        st = jcsw;
                    } else {
                        st = jczw;
                    }
                } else {
                    st = jcxw;
                }
                for (var i = st + 1; i <= jcws; i++) {
                    num += "晚上第" + (parseInt(sksj2[i].substring(2, 4), 10) - sw - zw - xw) + ",";
                }
            }
            num = num.substring(0, num.length - 1);
            return week + num + "节课";
        },
    },
};
</script>

<style scoped>
.el-row {
    padding-bottom: 0px;
}

.searchButton {
    margin: auto;
    text-align: center;
}

.filter-container {
    padding-bottom: 10px;
}

.el-checkbox-button /deep/ .el-checkbox-button__inner {
    width: 70px;
    border-radius: 0;
}

.checkfooter {
    height: 60px;
    margin-top: 10px;
    padding-bottom: 20px;
}
</style>
<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode #queryArea {
    height: 50px;
    margin: 20px 0 0 0;
}

#mobileMode #tipsArea {
    width: 100vw;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    color: #0055ff;
    text-align: center;
    display: none;
}

#mobileMode #contentArea {
    width: 96%;
    height: calc(100% - 160px);
    margin: 2%;
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: hidden;
}

.timetable {
    border-collapse: collapse;
    border-spacing: 0;
    text-align: center;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}

.timetable tr {
    height: 50px;
}

.timetable th {
    line-height: 20px;
    text-align: center;
}

.timetable td, .timetable th {
    border-right: 1px solid #DCDFE6;
    border-bottom: 1px solid #DCDFE6;
    padding: 0;
}

.timetableTitle {
    background-color: #F1FAF6;
    font-weight: bold;
}

.separetor {
    border-bottom: 4px double #DCDFE6 !important;
}

.timetableContent {
    width: 195px;
    font-size: 14px;
    word-break: break-all;
}

#mobileMode #detailDialog {
    top: 100px;
}

#mobileMode #detailDialogScroll {
    max-height: 60vh;
    padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// studentSelectionSportAdultEducationMobile.vue?d03a6bf0